import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { clearTicketDetailFromStorage } from "../../utils/ticket";
import { reloadIfNewBuildAvailable } from "../../utils/appVersion";
import { ArrowRight } from "../../compoment/icon";
import ScreenHeader from "../../compoment/ui/ScreenHeader";
import CircleButton from "../../compoment/ui/CircleButton";

const IdleScreen = () => {
  const navigate = useNavigate();

  const handleScanNow = () => {
    navigate("/qr-scan", { replace: true, state: { rescan: Date.now() } });
  };

  useEffect(() => {
    clearTicketDetailFromStorage();
    localStorage.removeItem("wish");
    localStorage.removeItem("join");
    localStorage.removeItem("gender");
    localStorage.removeItem("friendGender");
    // Pick up a newly deployed build (no session is running on this screen).
    reloadIfNewBuildAvailable();
  }, []);

  return (
    <section className="wishScreen wishScreen--home">
      <ScreenHeader />

      <main className="wishScreen__copy">
        <h1 className="wishScreen__title">
          IF YOU COULD
          <br />
          MAKE ONE WISH...
        </h1>
        <p className="wishScreen__prompt">
          Send your wish into the sky
          <br />
          and be part of a bigger light.
        </p>
      </main>

      <CircleButton label="START" icon={<ArrowRight />} onClick={handleScanNow} />
    </section>
  );
};

export default IdleScreen;
